import { useEffect, useState } from "react";

export default function useSyncedTrack(nowPlaying, audioTimeMs, playbackState) {
  const [currentTrack, setCurrentTrack] = useState(null);
  const [pendingTrack, setPendingTrack] = useState(null);

  // detect new metadata
  useEffect(() => {
    if (!nowPlaying?.history?.[0]) return;
    const newTrack = nowPlaying.history[0];

    if (!currentTrack || newTrack.startedAt !== currentTrack.startedAt) {
      setPendingTrack(newTrack);
    }
  }, [nowPlaying, currentTrack]);

  // check if audio reached new track start
  useEffect(() => {
    if (!pendingTrack) return;

    const check = () => {
      const pendingStart = new Date(pendingTrack.startedAt).getTime();
      const clockMs =
        playbackState === "playing" ? audioTimeMs : Date.now();

      if (clockMs >= pendingStart) {
        setCurrentTrack(pendingTrack);
        setPendingTrack(null);
      }
    };

    check();

    let interval;
    if (playbackState !== "playing") {
      interval = setInterval(check, 1000);
    }

    return () => clearInterval(interval);
  }, [audioTimeMs, pendingTrack, playbackState]);

  return currentTrack;
}
